import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/update/user.update.mutation.gql"
import type {
  UserUpdateMutation,
  UserUpdateMutationVariables,
} from "@/v2-backoffice-client/user/update/__types__/user.update.mutation"

type Options = MutationHookOptions<
  UserUpdateMutation,
  UserUpdateMutationVariables
>

export function useUserUpdateMutation(options?: Options) {
  return useMutation<UserUpdateMutation, UserUpdateMutationVariables>(
    mutation,
    options,
  )
}
